import React from 'react';
import { Mail, Phone, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { contact } from '../i18n/strings';

const Footer = () => {
  const { t } = useLanguage();

  const navLinks = [
    { label: t.nav.home, href: '#hero' },
    { label: t.nav.gallery, href: '#gallery' },
    { label: t.nav.legal, href: '/legal.html' },
    { label: t.nav.terms, href: '/terms.html' },
  ];

  return (
    <footer className="bg-[#06040c] border-t border-border-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold font-heading">
                Digi<span className="text-pink">Painto</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4 max-w-md">{t.footer.blurb}</p>
            <p className="text-slate-500 text-xs leading-relaxed max-w-lg">{t.footer.address}</p>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-5">{t.footer.linksTitle}</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-primary-light transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-5">{t.footer.contactTitle}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-primary-light transition-colors text-sm break-all"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contact.hotline.replace(/\s+/g, '')}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-primary-light transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 shrink-0" />
                  {contact.hotline}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border-dark pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs text-center md:text-left">{t.footer.copyright}</p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <a href="/legal.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.nav.legal}
            </a>
            <a href="/terms.html" className="text-slate-500 hover:text-accent transition-colors text-xs">
              {t.nav.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
